import { useRequest } from 'ahooks'
import { getFeeRate } from '@/api/network'

const useBtcFeeSummary = () => {
  return useRequest(
    async () => {
      return getFeeRate()
    },
    {
      cacheKey: 'btc-fee',
      pollingInterval: 30000,
    },
  )
}

export default useBtcFeeSummary
